import { z } from "zod";

/**
 * Extraction config — stored under `{ extraction: { ... } }`.
 * _v: 1
 */
export const ExtractionPromptConfigSchema = z.object({
  _v: z.literal(1).default(1),
  expectedData: z.record(z.string(), z.unknown())
});

export type ExtractionPromptConfig = z.infer<typeof ExtractionPromptConfigSchema>;
